import {
  renderBulletButton,
  syncBulletCurrent,
} from "../helpers/paginationBullets";

class SectionSlideshowNested extends HTMLElement {
  constructor() {
    super();
    this.slides = this.querySelectorAll(".slideshow-nested__item");

    this.duplicateSlidesCount = this.querySelectorAll(
      ".slideshow-nested__item:not(.slideshow-nested__item--duplicate)",
    ).length;

    window.loadSwiper.then(({ Swiper, Pagination, Navigation }) => {
      const swiperParams = {
        modules: [Pagination, Navigation],
        loop: this.slides.length > 2,
        slidesPerView: "auto",
        centeredSlides: true,
        spaceBetween: 8,
        navigation: {
          nextEl: this.querySelector("[data-navigation-next]"),
          prevEl: this.querySelector("[data-navigation-previous]"),
        },
        breakpoints: {
          1024: {
            spaceBetween: 24,
          },
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          renderBullet: renderBulletButton,
        },
        on: {
          init: (swiper) => {
            this.updateNavPosition(swiper);
            this.updatePaginationPosition(swiper);
          },
          slideChange: (swiper) => {
            this.updateNavPosition(swiper);
            this.updatePaginationPosition(swiper, swiper.activeIndex);
          },
          resize: (swiper) => {
            this.updateNavPosition(swiper);
          },
          paginationUpdate: syncBulletCurrent,
        },
      };

      // When using uplicate slides we need to handle pagination in a special way
      // Approach pulled from https://github.com/nolimits4web/swiper/issues/7254#issuecomment-4193273635
      if (this.duplicateSlidesCount) {
        swiperParams.pagination.renderBullet = (index, className) =>
          index < this.duplicateSlidesCount
            ? renderBulletButton(index, className)
            : "";

        swiperParams.on.realIndexChange = (swiper) => {
          const bullets = swiper.pagination?.bullets;
          if (!bullets || !bullets.length) return;

          // Calculate the true active index using modulo math
          const realIndex = swiper.realIndex % this.duplicateSlidesCount;

          // Loop through the remaining bullets and toggle the active class
          bullets.forEach((bullet, i) => {
            bullet.classList.toggle(
              "swiper-pagination-bullet-active",
              i === realIndex,
            );
          });

          // Runs after paginationUpdate, so aria-current still reflects the
          // classes this just replaced.
          syncBulletCurrent(swiper);
        };
      }
      this.swiper = new Swiper(this.querySelector(".swiper"), swiperParams);
    });
  }

  updateNavPosition(swiperInstance) {
    const activeSlide = swiperInstance.slides[swiperInstance.activeIndex];
    if (!activeSlide) return;

    const imgContainer = activeSlide.querySelector(
      ".slideshow-nested__item-image",
    );
    if (!imgContainer) return;

    const imgHeight = imgContainer.offsetHeight;

    swiperInstance.el.style.setProperty(
      "--current-alignment-height",
      `${imgHeight}px`,
    );
  }

  updatePaginationPosition(swiperInstance, currentIndex = 0) {
    const currentSlide = swiperInstance.slides[currentIndex];
    const slideImage = currentSlide.querySelector("img");

    if (!slideImage) return;

    this.style.setProperty(
      "--pagination-spacer-aspect-ratio",
      slideImage.dataset.aspectRatio,
    );
  }
}

if (!customElements.get("section-slideshow-nested")) {
  customElements.define("section-slideshow-nested", SectionSlideshowNested);
}
